import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, DialogContentText } from '@mui/material';
import { useRef, useState } from 'react';
import { useRootStore } from '../hooks/useRootStore';
import { MdxPlugins } from './MarkdownEditor/MarkdownEditorPlugins';
import { MDXEditor, MDXEditorMethods } from '@mdxeditor/editor';
import useDeviceMedia from '../hooks/useDeviceMedia';

export interface NewActivityData {
    issueId: number,
    skillId: number,
    comment: string,
    timeStart: Date,
    timeEnd: Date,
    isOffDuty: boolean,
}

export default function PauseIssueDialog({ issueId, onSubmit, onCancel }: { issueId: number, onSubmit: (comments: string) => void, onCancel: () => void }) {

    const [textNotSpecified, setTextNotSpecified] = useState(false);
    const { api } = useRootStore();
    const { isMobile } = useDeviceMedia();

    const mdxEditorRef = useRef<MDXEditorMethods>(null);

    const pauseIssue = async () => {
        const comments = (mdxEditorRef.current?.getMarkdown() ?? '').trim();
        if (comments.trim().length == 0) {
            setTextNotSpecified(true);
            return false;
        } else {
            setTextNotSpecified(false);
            await api.pauseIssue(issueId, comments)
                .then(() => onSubmit(comments));
        }
    }

    return (
        <Dialog
            open={true}
            fullWidth={true}
            maxWidth='lg'
            onClose={onCancel}
        >
            <DialogTitle>Приостановка задачи</DialogTitle>
            <DialogContent sx={{ minHeight: '40vh' }}>
                <DialogContentText>
                    Уточните, какая необходима информация
                </DialogContentText>
                <Box sx={{ mt: 0.5, textAlign: 'left', minHeight: '300px', border: `1px solid ${textNotSpecified ? 'red' : '#cccccc'}`, borderRadius: 1 }} onClick={() => mdxEditorRef.current?.focus()}>
                    <MDXEditor
                        ref={mdxEditorRef}
                        markdown={''}
                        plugins={MdxPlugins.standardPlugins(api, issueId, '', isMobile)}
                        onChange={() => setTextNotSpecified(false)}
                    />
                </Box>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel}>Отмена</Button>
                <Button onClick={pauseIssue}>Приостановить</Button>
            </DialogActions>
        </Dialog>
    );
}